import { render, staticRenderFns } from "./ReturnDetail.vue?vue&type=template&id=0ee4ed32&scoped=true&"
import script from "./ReturnDetail.vue?vue&type=script&lang=js&"
export * from "./ReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReturnDetail.vue?vue&type=style&index=0&id=0ee4ed32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee4ed32",
  null
  
)

export default component.exports